var checkCurrentLocation, cllCookie, detectCurrentLocation, error, errorCallback, success, successCallback,
  slice = [].slice;

cllCookie = require('./m_location_helper').cllCookie;

successCallback = void 0;

errorCallback = void 0;


/*
 * HTML5 Geolocation API success callback
 *
 * @callback success
 * @param   {Object}   position        - Position information returned by Geolocation API
 * @returns {function} successCallBack - Callback to proceed in the search form submit
 */

success = function(position) {
  var lat, lng, ref;
  ref = position != null ? position.coords : void 0, lat = ref.latitude, lng = ref.longitude;
  Groupon.Utils.trackEvent('client-geolocate-successful', {
    lat: lat,
    lng: lng
  });
  setInterval(checkCurrentLocation, 1000 * 60 * 5);
  cllCookie.set(position);
  return typeof successCallback === "function" ? successCallback({
    lat: lat,
    lng: lng,
    current: true
  }) : void 0;
};


/*
 * HTML5 Geolocation API error callback
 *
 * @callback error
 * @param   {Object}   err           - Error object returned by Geolocation API
 * @returns {Function} errorCallback - Callback to exit search form submit
 */

error = function(err) {
  Groupon.Utils.trackEvent('client-geolocate-failed', err);
  cllCookie.remove(err);
  return typeof errorCallback === "function" ? errorCallback(err) : void 0;
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Object}   [positionOptions] - Configuration  of Geolocation API (Optional)
 * @param {Function} [successCB]       - Callback for successful geolocation (Optional)
 * @param {Function} [errorCB]         - Callback for failed geolocation (Optional)
 */

checkCurrentLocation = function(positionOptions, successCB, errorCB) {
  if (positionOptions == null) {
    positionOptions = {};
  }
  if (successCB == null) {
    successCB = cllCookie.set;
  }
  if (errorCB == null) {
    errorCB = cllCookie.remove;
  }
  if (positionOptions.maximumAge || positionOptions.timeout) {
    navigator.geolocation.getCurrentPosition(successCB, errorCB, positionOptions);
  } else {
    navigator.geolocation.getCurrentPosition(successCB, errorCB);
  }
};


/*
 * Function to determine parameters for HTML5 Geolocation API
 *
 * @param {Function[]} arg                   - Splat of arguments containing success and error function
 * @param {Function}   arg[].successCallback - Callback for successful geolocation (Optional)
 * @param {Function}   arg[].errorCB         - Callback for failed geolocation (Optional)
 */

detectCurrentLocation = function() {
  var arg, positionOptions, ref;
  arg = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  successCallback = arg[0], errorCallback = arg[1];
  if (!navigator.geolocation) {
    return typeof errorCallback === "function" ? errorCallback() : void 0;
  }
  positionOptions = ((ref = Groupon.LS.options) != null ? ref.geolocationOptions : void 0) || {};
  return checkCurrentLocation(positionOptions, success, error);
};

module.exports = {
  checkCurrentLocation: checkCurrentLocation,
  currentLocationSuccess: success,
  currentLocationError: error,
  detectCurrentLocation: detectCurrentLocation
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC9oZWxwZXIvbV9kZXRlY3RDdXJyZW50TG9jYXRpb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC9oZWxwZXIvbV9kZXRlY3RDdXJyZW50TG9jYXRpb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsc0dBQUE7RUFBQTs7QUFBRSxZQUFjLE9BQUEsQ0FBUSxxQkFBUjs7QUFDaEIsZUFBQSxHQUFrQjs7QUFDbEIsYUFBQSxHQUFrQjs7O0FBRWxCOzs7Ozs7OztBQU9BLE9BQUEsR0FBVSxTQUFDLFFBQUQ7QUFDUixNQUFBO0VBQUEseUJBQWtDLFFBQVEsQ0FBRSxlQUE1QyxFQUFXLFVBQVYsUUFBRCxFQUEyQixVQUFYO0VBQ2hCLE9BQU8sQ0FBQyxLQUFLLENBQUMsVUFBZCxDQUF5Qiw2QkFBekIsRUFBd0Q7SUFBQyxLQUFBLEdBQUQ7SUFBTSxLQUFBLEdBQU47R0FBeEQ7RUFDQSxXQUFBLENBQVksb0JBQVosRUFBa0MsSUFBQSxHQUFPLEVBQVAsR0FBWSxDQUE5QztFQUNBLFNBQVMsQ0FBQyxHQUFWLENBQWMsUUFBZDtpREFDQSxnQkFBaUI7SUFBQyxLQUFBLEdBQUQ7SUFBTSxLQUFBLEdBQU47SUFBVyxPQUFBLEVBQVMsSUFBcEI7O0FBTFQ7OztBQU9WOzs7Ozs7OztBQU9BLEtBQUEsR0FBUSxTQUFDLEdBQUQ7RUFDTixPQUFPLENBQUMsS0FBSyxDQUFDLFVBQWQsQ0FBeUIseUJBQXpCLEVBQW9ELEdBQXBEO0VBQ0EsU0FBUyxDQUFDLE1BQVYsQ0FBaUIsR0FBakI7K0NBQ0EsY0FBZTtBQUhUOzs7QUFLUjs7Ozs7Ozs7QUFPQSxvQkFBQSxHQUF1QixTQUFDLGVBQUQsRUFBdUIsU0FBdkIsRUFBa0QsT0FBbEQ7O0lBQUMsa0JBQWtCOzs7SUFBSSxZQUFZLFNBQVMsQ0FBQzs7O0lBQUssVUFBVSxTQUFTLENBQUM7O0VBQzNGLElBQUcsZUFBZSxDQUFDLFVBQWhCLElBQThCLGVBQWUsQ0FBQyxPQUFqRDtJQUNFLFNBQVMsQ0FBQyxXQUFXLENBQUMsa0JBQXRCLENBQXlDLFNBQXpDLEVBQW9ELE9BQXBELEVBQTZELGVBQTdELEVBREY7R0FBQSxNQUFBO0lBR0UsU0FBUyxDQUFDLFdBQVcsQ0FBQyxrQkFBdEIsQ0FBeUMsU0FBekMsRUFBb0QsT0FBcEQsRUFIRjs7QUFEcUI7OztBQU92Qjs7Ozs7Ozs7QUFPQSxxQkFBQSxHQUF3QixTQUFBO0FBQ3RCLE1BQUE7RUFEdUI7RUFDdEIsd0JBQUQsRUFBa0I7RUFDbEIsSUFBQSxDQUErQixTQUFTLENBQUMsV0FBekM7QUFBQSxpREFBTyx5QkFBUDs7RUFDQSxlQUFBLDRDQUFvQyxDQUFFLDRCQUFwQixJQUEwQztTQUU1RCxvQkFBQSxDQUFxQixlQUFyQixFQUFzQyxPQUF0QyxFQUErQyxLQUEvQztBQUxzQjs7QUFReEIsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDZixzQkFBQSxvQkFEZTtFQUVmLHNCQUFBLEVBQXdCLE9BRlQ7RUFHZixvQkFBQSxFQUFzQixLQUhQO0VBSWYsdUJBQUEscUJBSmUifQ==
